import { Field, Form } from '@dnb/eufemia/extensions/forms';
import classNames from 'classnames';
import React from 'react';

import { ApiLifeCycleRequest } from '@/openapi/schema';
import { ApiStageTimeLineFormData } from '@/pages/profile/apps/application/ApiProviderPage/LifecycleManagementTab/LifecycleManagementSection/components/ApiStageTimeLineForm';

import styles from './index.module.css';

type ApiStage = ApiLifeCycleRequest['stage'];

export const STAGE_OPTIONS: Record<ApiStage, string> = {
  UPCOMING: 'Upcoming',
  LAUNCHED: 'Launched',
  DEPRECATED: 'Deprecated',
  DECOMMISSIONED: 'Decommissioned',
};

export const STAGE_ORDER: ApiStage[] = ['UPCOMING', 'LAUNCHED', 'DEPRECATED', 'DECOMMISSIONED'];

type ApiStageTimeLineProps = {
  formId: string;
  interactive: boolean;
  isSaving?: boolean;
};

const ApiStageTimeLine = ({ formId, interactive, isSaving = false }: ApiStageTimeLineProps) => {
  const activeStage = Form.getData<ApiStageTimeLineFormData>(formId).data?.stage;

  return (
    <Field.Selection
      className={styles['TimelineSelection']}
      disabled={isSaving}
      optionsLayout="horizontal"
      path="/stage"
      size="large"
      variant="radio"
    >
      <div className={styles['TimelineSelectionContainer']}>
        {!interactive && <div aria-hidden="true" className={styles['InteractionBlocker']} />}
        {STAGE_ORDER.map((stage, idx) => (
          <React.Fragment key={stage}>
            <div className={styles['StageWrapper']}>
              <Field.Option key={stage} value={stage} />
              <label
                className={classNames(styles['StageName'], {
                  [styles['ActiveName']!]: activeStage !== undefined && activeStage === stage,
                })}
              >
                {STAGE_OPTIONS[stage]}
              </label>
            </div>

            {idx < STAGE_ORDER.length - 1 && (
              <div
                className={classNames(styles['StageLine'], {
                  [styles['LineBlueGreen']!]: idx === 0,
                  [styles['LineGreenYellow']!]: idx === 1,
                  [styles['LineYellowRed']!]: idx === 2,
                  [styles['StageLineSaving']!]: isSaving,
                })}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </Field.Selection>
  );
};

export default ApiStageTimeLine;
